export default "__VITE_ASSET__C13cP1Dt__"